import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import DeleteAlert from "../../../../../../../assets/icons/error-alert.svg";
import CloseIcon from "@mui/icons-material/Close";
import "./delete-dialog.scss";

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  campaignToDelete: {
    customerId: number;
    associationId: number;
    name: string;
  } | null;
  customerName: string;
  confirmDeleteCampaign: () => void;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({
  open,
  onClose,
  campaignToDelete,
  customerName,
  confirmDeleteCampaign,
}) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      PaperProps={{ className: "custom-delete-dialog" }}
    >
      <div className="delete-dialog-header">
        <img src={DeleteAlert} alt="Alert" className="alert-icon" />
        <CloseIcon onClick={onClose} className="close-icon" />
      </div>

      <DialogContent className="delete-dialog-content">
        <Typography variant="h6" textAlign="left" fontSize={18}>
          Unassign <b>{campaignToDelete?.name}</b> Campaign from{" "}
          <b>{customerName}</b> Customer?
        </Typography>
      </DialogContent>

      <DialogActions className="delete-dialog-actions">
        <button onClick={onClose} className="cancel-button half-width">
          Cancel
        </button>
        <button
          onClick={confirmDeleteCampaign}
          className="cancel-button next-button-wrapper half-width unassign-button"
        >
          Unassign
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
